    
<template>
    <div class="dashBox">
        <div class="dashTitle">{{ data.isoverview ? '关注系统异常趋势(每小时更新)' : '异常历史趋势'}}</div>
        <a-empty v-if="data.listthread.length == 0" :description="data.isoverview ? '暂无数据，定时任务是否执行或是否关注系统？' : '暂无数据'" style="margin-top:80px;" />

        <div :id="chartID" style="width: 100%;padding-top:10px;"></div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            sysList:[],
            dateList:[],
            seriesList:[],
            chartSys:null,
        }
    },
    props:{
        chartID:String,
        data:{
            listthread:[],
            isoverview:Boolean,
            isperhour:Boolean
        }
    },
    methods: {
        handleChartData(originData){
            let that = this;
            that.sysList = [];
            that.dateList = [];
            that.seriesList = [];
            for (let index = 0; index < originData.length; index++) {
                const element = originData[index];
                if(that.data.isperhour){
                    element.occurtime = (new Date(element.occurtime)).Format('MM-dd hh:mm');
                }
                else{
                    element.occurtime = (new Date(element.occurtime)).Format('MM-dd');
                }
                if(that.sysList.indexOf(element.logstorename) == -1){
                    that.sysList.push(element.logstorename)
                }
                if(that.dateList.indexOf(element.occurtime) == -1){
                    that.dateList.push(element.occurtime)
                }
            }
            //时间排序
            that.handleChartSys();
            //遍历系统名
        },
        //按系统组织数据
        handleChartSys(){
            let array = this.sysList;
            for (let index = 0; index < array.length; index++) {
                const sysname = array[index];
                let data_s = this.handleChartDay(sysname);
                let sysItem = {
                    name: sysname,
                    type: 'line',
                    areaStyle: {},
                    emphasis: {
                        focus: 'series'
                    },
                    data: data_s
                }
                this.seriesList.push(sysItem);
            }
        },
        handleChartDay(sysname){
            let array = this.dateList;
            let that = this;
            let result = [];
            for (let index = 0; index < array.length; index++) {
                const element = array[index];
                //按时间和系统名查找对应值
                let target = that.data.listthread.filter(function(n){
                    return n.logstorename == sysname && n.occurtime == element;
                });
                if(target.length > 0){
                    result.push(target[0].ecount)
                }
                else{
                    result.push(0)
                }
            }
            return result;
        },
        //按日期统计数据
        analystData(){
            let that = this;

            if(this.data.listthread.length == 0){
                if(that.chartSys){
                    that.chartSys.clear();
                    document.getElementById(that.chartID).style.height = "0";
                }
                return
            }
            that.handleChartData(this.data.listthread);
            if(that.chartSys){
                that.chartSys.clear();
            }
            document.getElementById(that.chartID).style.height = "360px";
            that.chartSys = that.$echarts.init(document.getElementById(that.chartID));
            
            let option = that.getDatailOption();
            // 窗口大小自适应方案
            that.chartSys.setOption(option);
            that.chartSys.off('click');
            that.chartSys.on('click', function (params) {
                if(params.name){
                    let yearstr = new Date().Format('yyyy');
                    let resultDate = yearstr + '-' + params.name.replace('\n',' ')
                    that.$emit("qschartCLick",resultDate)
                }
            });
            
        },
        getDatailOption(){
            let that = this;
           
            // 基于准备好的dom，初始化echarts实例
            // 绘制图表配置
            let option = {
                title: {
                    show: false
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        label: {
                            backgroundColor: '#6a7985'
                        }
                    }
                },
                color:that.G.getChartColors(),

                legend: {
                    data: that.sysList,
                    left: 'center',
                    top:'top',
                },
                // toolbox: {
                //     feature: {
                //         saveAsImage: {}
                //     }
                // },
                grid: {
                    // left: '3%',
                    // right: '4%',
                    // bottom: '3%',
                    // containLabel: true
                },
                xAxis: [
                    {
                        type: 'category',
                        boundaryGap: false,
                        axisLine: {onZero: false},
                        data: that.dateList.map(function (str) {
                            return str.replace(' ', '\n');
                        })
                    }
                ],
                yAxis: [
                    {
                        type: 'value'
                    }
                ],
                series: that.seriesList
            };
            return option
        },
        chartResize(){
            let eleArr = [this.chartSys];
            for(let i = 0; i<eleArr.length; i++){
                //此处定时器是为了在页面存在多个图时，resize方法的调用时间微微错开，避免明显的卡顿
                setTimeout(function(){
                    if(eleArr[i]){
                        eleArr[i].resize();
                    }
                }, 200);
            }
        },
    },
    mounted() {
        window.addEventListener("resize", this.chartResize);
    },
    destroyed(){
        window.removeEventListener("resize", this.chartResize);

    },
    watch:{
        'data.listthread'(newVal){
            if(newVal){
                this.analystData();
            }
        }
    }
}
</script>

<style scoped>

    .dashBox{
        min-height: 395px;
        border: 1px solid lightgray;
        padding-bottom: 20px;
        background-color: white;
    }
    .dashTitle{
        width: 100%;
        height: 40px;
        color: #00c1de;
        line-height:38px;
        padding:0 10px;
        border-bottom: 1px solid lightgray;
        cursor: default;
    }
</style>
